.OuterContainer
    position: relative
    display: block
    overflow: visible
    width: 100%
    text-align: center
    margin-top: 16px

.SelectContainer
    position: relative
    background-color: rgba(0, 0, 0, 0)
    text-align: left
    width: 100%
    height: 40px
    box-sizing: border-box
    border: 1px rgb($globalSettingsStrokeSecondary) solid
    border-radius: 0 $globalButtonRounding $globalButtonRounding $globalButtonRounding
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    margin: 0
    padding: 0 10px
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    stroke: rgb($globalSettingsFontSecondary)
    gap: 5px
    &:hover
        border-color: rgb($globalSettingsStrokePrimary)
    &:focus
        outline: none
        border-color: rgb($globalSettingsStrokePrimary)
    &:disabled
        &:hover
            border-color: rgb($globalSettingsStrokeSecondary)
        &:focus
            border-color: rgb($globalSettingsStrokeSecondary)
    .SelectChevronSVG
        width: 13px
        height: 7px

.Label
    position: absolute
    top: -1em
    left: 0
    height: 1em
    line-height: 1em
    z-index: 1
    display: inline-block
    vertical-align: text-top
    padding: 0 2px 0 0
    font-weight: 700
    pointer-events: none
    color: rgb($globalSettingsFontTertiary)
    white-space: nowrap
    user-select: none
    border-bottom: 1px solid rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box

.Red
    color: rgb($globalErrorBackground)

.LeftInner
    min-width: 0
    margin-right: 6px
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    gap: 5px
    .TimeContainer
        margin: 0
        padding: 0 5px 0 10px
        min-width: 0
        font-size: 14px
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        span
            display: inline-flex
            flex-direction: column
            color: rgb($globalSettingsFontPrimary)
            &::after
                content: attr(data-text) / ""
                height: 0
                visibility: hidden
                overflow: hidden
                user-select: none
                pointer-events: none

.ExpandedContainerOuter
    width: 100%
    position: absolute
    left: 0
    top: 50px
    z-index: $indexPicker
    display: flex
    flex-direction: column

.ExpandUp
    top: unset
    bottom: 60px

.ExpandedContainer
    width: 100%
    background: rgb($globalSettingsBackgroundPrimary)
    margin: 0
    padding: 0
    border: 1px rgb($globalSettingsStrokeSecondary) solid
    border-radius: $globalButtonRounding
    box-sizing: border-box
    overflow: hidden

.ExpandedInner
    width: 100%
    max-height: 200px
    overflow-y: auto
    margin: 0
    padding: 10px 0
    box-sizing: border-box
    .Item
        padding: 5px 15px
        margin: 0
        font-size: 14px
        cursor: pointer
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
            font-weight: 700
